import { IdhaAppException } from "../../../../js/idha-app-exception";
import { material } from "angular";
import { ICpf, ICnpj, ICpfCnpj } from "../../../utils/services/cpfCnpjService";
import * as topbarActions from '../../../../redux/actions/topbar.actions'
import { loginModule } from "../../login-module";

var CPF = require("@fnando/cpf/dist/node");
var CNPJ = require("@fnando/cnpj/dist/node");

function welcomeToIdhaController($scope, appInfo, Person, $state,
    cpf: ICpf, cnpj: ICnpj, cpfCnpj: ICpfCnpj,$ngRedux) {
    var ctrl = this;
    let ownerId: string = undefined;
    let person = undefined;
    let user = undefined;

    ctrl.validated = false;

    ctrl.$onInit = function () {

        //verificar se o usuário já está logado, checando a chave $Loopback$currentUserId no localStorage
        let accessToken: string = window.localStorage.getItem('$LoopBack$accessTokenId') || '';
        if (accessToken !== "") {
            $state.go("home");
        }

    }

    this.start = async function () {
        ctrl.validated = true;
        if (!$scope.formId.$invalid) {
            try {
                let identifierType: string = undefined;

                if (ctrl.ownerIdIsCNPJ()) {
                    identifierType = "CNPJ";
                    this.ownerId = cpfCnpj.strip(this.ownerId);
                } else if (ctrl.ownerIdIsCPF()) {
                    identifierType = "CPF";
                    this.ownerId = cpfCnpj.strip(this.ownerId);
                } else {
                    throw new IdhaAppException("Identificador inválido");
                }

                let checkPersonExistenceResponse: {
                    personExistsForGivenIdentifier: boolean,
                    personId: string,
                    userId: string,
                    userExistsForGivenIdentifier: boolean
                } = await Person.checkPersonAndUserExistence({
                    identifier: ctrl.ownerId,
                    identifierType: identifierType
                }).$promise;

                //se a pessoa existir, buscar seus dados, caso contário preencher os dados conhecidos localmente
                //para posterior cadastro
                if (checkPersonExistenceResponse.personExistsForGivenIdentifier) {
                    throw new IdhaAppException("Identificador já cadastrado")
                }
                if (checkPersonExistenceResponse.userExistsForGivenIdentifier) {
                    throw new IdhaAppException("Identificador já cadastrado")
                }
                $state.go('loginRegister', {
                    identifier: ctrl.ownerId,
                    /* identifierType: identifierType */
                })

            } catch (ex) {
                $scope.formId.identifier.$invalid = true;

                if (ex instanceof IdhaAppException) {
                    $scope.formId.identifier.$error = { invalid: true, message: (<IdhaAppException>ex).msg }
                } else {
                    console.error(ex);
                }
            }
        }
    }



    this.ownerIdIsEmail = function () {
        let emailRegex: RegExp = /^[a-zA-Z0-9.-_]*@[a-zA-Z0-9.-_]*$/;
        return emailRegex.test(this.ownerId);
    }

    this.ownerIdIsCPF = function () {
        //return (this.ownerId != undefined) && (this.ownerId.length == 11) && (CPF.isValid(this.ownerId));
        console.log("CPF",cpf.isValid(this.ownerId));
        return cpf.isValid(this.ownerId)
    }

    this.ownerIdIsCNPJ = function () {
        //return (this.ownerId != undefined) && (this.ownerId.length == 14) && (CNPJ.isValid(this.ownerId));;
        return cnpj.isValid(this.ownerId)
    }
}

loginModule.component('welcomeToIdha', {
    template: require('./welcome-to-idha.component.html'),
    controller: ['$scope', 'appInfo', 'Person', '$state',
        'cpf', 'cnpj', 'cpfCnpj','$ngRedux', welcomeToIdhaController],
    bindings: {
        onBackToLoginClick: '&'
    }

});